import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { DISCOVERY_CARD_BASE_CLASSNAME } from './Constants';
import { createDiscoveryCard } from './DiscoveryCard';
createComponents(".".concat(DISCOVERY_CARD_BASE_CLASSNAME), createDiscoveryCard, NO_PATTERN_BUSINESS_LOGIC);
